import { render, staticRenderFns } from "./LpuCard.vue?vue&type=template&id=5670f806&scoped=true&"
import script from "./LpuCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuCard.vue?vue&type=style&index=0&id=5670f806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670f806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5670f806')) {
      api.createRecord('5670f806', component.options)
    } else {
      api.reload('5670f806', component.options)
    }
    module.hot.accept("./LpuCard.vue?vue&type=template&id=5670f806&scoped=true&", function () {
      api.rerender('5670f806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/LpuCard.vue"
export default component.exports